import { render, staticRenderFns } from "./MainContentSwioon.vue?vue&type=template&id=e5e6da00&"
import script from "./MainContentSwioon.vue?vue&type=script&lang=js&"
export * from "./MainContentSwioon.vue?vue&type=script&lang=js&"
import style0 from "./MainContentSwioon.vue?vue&type=style&index=0&id=e5e6da00&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports